export type BlockSortKey = "size" | "due";

// sortBlocks orders a block list: "size" is largest first; "due" is soonest due
// date first with undated blocks last, ties broken by size (largest first).
export function sortBlocks<T extends { size: number; due_date: string | null }>(blocks: T[], key: BlockSortKey): T[] {
  return [...blocks].sort((a, b) => (key === "due" ? compareDueDates(a.due_date, b.due_date) : 0) || b.size - a.size);
}

// Due dates are YYYY-MM-DD strings, so string order is calendar order.
function compareDueDates(a: string | null, b: string | null): number {
  if (a === b) {
    return 0;
  }
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }
  return a < b ? -1 : 1;
}
